import { render, staticRenderFns } from "./SessionsList.vue?vue&type=template&id=32f7fc8a&scoped=true&lang=pug&"
import script from "./SessionsList.vue?vue&type=script&lang=js&"
export * from "./SessionsList.vue?vue&type=script&lang=js&"
import style0 from "./SessionsList.vue?vue&type=style&index=0&id=32f7fc8a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f7fc8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
